module.exports = "pegasus/assets/tech/email1-gallery-img6.png";